import { Injectable } from '@angular/core';
import { DatasourceTableService, DatasourceTableSettingsCheckService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { Y42FeatureType } from '@y42/json-schema';
import {
  SqlModelingQuery,
  SqlModelingStore,
  SqlModelingTableGitFactoryService,
  SqlModelingTableJobQuery,
  SqlModelingTableQuery,
  SqlModelingTableStore,
} from '../../state';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableService extends DatasourceTableService {
  constructor(
    parentStore: SqlModelingStore,
    parentQuery: SqlModelingQuery,
    query: SqlModelingTableQuery,
    store: SqlModelingTableStore,
    jobQuery: SqlModelingTableJobQuery,
    gitFactory: SqlModelingTableGitFactoryService,
    errorHandlerService: ErrorHandlerService,
    datasourceTableSettingsCheckService: DatasourceTableSettingsCheckService,
  ) {
    super({
      feature: Y42FeatureType.SqlModel,
      parentStore,
      parentQuery,
      query,
      store,
      jobQuery,
      gitFactory,
      errorHandlerService,
      datasourceTableSettingsCheckService,
    });
  }
}
